// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2wZ3U","inputWrap":"CustomTip_inputWrap__In-m5"};